import React, { useMemo } from 'react';
import { BeveledPanel } from '../FabProcessTool/BeveledPanel';
import {
  getBlueIndustrialGlass,
  getWhitePaintedMetal,
} from '../FabProcessTool/equipmentMaterials';
import type { Awp300Layout } from './awp300Layout';

export type Awp300RacksProps = {
  layout: Awp300Layout;
  opacity?: number;
  levels?: number;
};

/** Internal buffer racks — left/right columns with spaced tiers. */
export const Awp300Racks: React.FC<Awp300RacksProps> = ({
  layout,
  opacity = 1,
  levels = 4,
}) => {
  const shelf = useMemo(() => getWhitePaintedMetal(opacity), [opacity]);
  const glass = useMemo(() => getBlueIndustrialGlass(opacity, 'high'), [opacity]);

  const { width, depth, rackBottom, rackTop, frameT } = layout;
  const slotX = width * 0.3;
  const gapY = (rackTop - rackBottom) / Math.max(1, levels);
  const shelfD = depth * 0.22;
  const shelfT = frameT * 0.35;

  return (
    <group name="Awp300Racks">
      {Array.from({ length: levels }, (_, level) => {
        const y = rackBottom + level * gapY;
        return (
          <group key={`tier-${level}`}>
            {([-1, 1] as const).map((side) => (
              <BeveledPanel
                key={`shelf-${level}-${side}`}
                size={[width * 0.22, shelfT, shelfD]}
                material={level % 2 === 0 ? shelf : glass}
                position={[side * slotX, y, depth * 0.12]}
                radius={shelfT * 0.15}
              />
            ))}
          </group>
        );
      })}
    </group>
  );
};

export default Awp300Racks;
